<template>
  <el-dialog title="查看逾期未付汇明细" width="700px" class="import-statement-dialog" v-model="dialog.show" :before-close="closeDialog" :close-on-click-modal='false'>
    <ab-table
      border
      showOrder
      index-label="序号"
      indexWidth="60"
      maxHeight="226"
      :column-list="columns"
      :table-list="tableData"
      :dataListLoading="tableLoading">
    </ab-table>
    <template #footer>
        <div class="dialog-footer">
            <div class="sum">合计：{{dialog.data.overduePayableStr}}</div>
            <el-button @click="closeDialog">取 消</el-button>
        </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'import-statement-overdue-dialog',
  props: {
    dialog: {
      type: Object
    }
  },
  data () {
    return {
      tableLoading: false,
      columns: [
        {
          labels: '订单编号',
          props: 'custOrderNo',
          widths: 130
        },
        {
          labels: '应付汇日期',
          props: 'shouldDate',
          widths: 105
        },
        {
          labels: '供应商',
          props: 'supplierName',
          widths: 200
        },
        {
          labels: '金额',
          props: 'prePaymentAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '币别',
          props: 'currencyNumber',
          widths: 60
        }
      ],
      tableData: []
    }
  },
  watch: {
    dialog: {
      handler: function (val, oldval) {
        this.getOverdueData()
      },
      deep: true
    }
  },
  computed: {

  },
  mounted () {
    
  },
  methods: {
    getOverdueData () {
      this.tableData = this.dialog.data.overduePayableEntryList || []
    },

    closeDialog () {
      this.dialog.show = false
      this.dialog.data = {}
    }
  }
}
</script>

<style lang="scss">
.import-statement-dialog {
  .el-dialog__footer {
    position: relative;
  }
  .sum {
    position: absolute;
    top: -30px;
    left: 0;
    width: 400px;
    height: 42px;
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;
    line-height: 42px;
    text-align: left;
    color: #FA7F14;
  }
}
</style>
